module.exports = __webpack_public_path__ + "img/1.092bebe8.png";